import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

// Root ('/') target: no UI of its own, only consumes the post-auth/sign-out
// sessionStorage redirects set by azureAdAuthGuard, header sign-out and bq-auth-select.
@Component({
  selector: 'app-root-redirect',
  standalone: true,
  template: '',
})
export class RootRedirectComponent implements OnInit {
  private router = inject(Router);

  ngOnInit() {
    // When Azure AD redirects back with an auth code in the URL, MSAL (via CAL)
    // needs to process it and will call location.reload() when done.
    // Do NOT consume redirectUrl yet — wait for the reload on a clean URL.
    const hasAuthCode = window.location.search.includes('code=') ||
      window.location.hash.includes('code=');
    if (hasAuthCode) return;

    // Handle post-auth redirect (after Azure AD sign-in, second load after MSAL reload)
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    if (redirectUrl) {
      sessionStorage.removeItem('redirectUrl');
      this.router.navigateByUrl(redirectUrl);
      return;
    }

    // Handle post-signout redirect (back to BQ auth selection)
    const postSignOutRedirect = sessionStorage.getItem('postSignOutRedirect');
    if (postSignOutRedirect) {
      sessionStorage.removeItem('postSignOutRedirect');
      this.router.navigateByUrl(postSignOutRedirect);
      return;
    }

    // No pending redirect: send to the default module (guard will trigger sign-in)
    this.router.navigateByUrl('/sdd/suppliers');
  }
}
